import React, { useState } from 'react';
import LoadingAnimation from '../../assets/dsp-loading.svg';
import styled from "styled-components";

const LoadingWrapper = styled.div`
    position:absolute;
    left:0;
    top:0;
    width:100%;
    height:100%;
    background:rgba(255,255,255,0.7);
    z-index:10;
    
    >img {
        width: 40px;
        position:absolute;
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;
    }
`;

export const LoadingShell = styled.div`
    position: relative;
    padding: ${({ padding = '12px' }) => padding};
    height: ${({ height = '150px' }) => height};
`;


const useLoading = (initialState = true) => {
    const [isLoading, setInternalLoading] = useState(initialState);

    const setLoading = (status) => {
        setInternalLoading(status);
    };

    return [isLoading, setLoading];

};

const Loading = ({ ...props }) => (<img src={LoadingAnimation} {...props} alt='loading' />);


const LoadingContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: ${({ margin }) => margin || '0'};
    height: ${({ containerHeight }) => containerHeight || '100%'};
    width: ${({ containerWidth }) => containerWidth || '100%'};
    ${({ overlay }) => overlay &&
        `
            position: absolute;
            inset: 0;
            background: rgba(255, 255, 255, 0.6);
            z-index: 100;
        `
    }
    
    img {
        height: ${({ imgHeight }) => imgHeight || 'auto'};
        width: ${({ imgWidth }) => imgWidth || '100px'};

        ${({ imgMarginTop }) => imgMarginTop && `
            align-self: flex-start;
            margin-top: ${imgMarginTop};
        `}
    }
`;

/**
 * @param {{
 *   containerHeight?: string | number,
 *   containerWidth?: string | number,
 *   imgHeight?: string | number,
 *   imgWidth?: string | number,
 *   imgMarginTop?: string | number,
 *   overlay?: boolean,
 * }} props
 */
const LoadingView = ({ containerHeight = null, containerWidth = null, imgHeight = null, imgWidth = null, imgMarginTop = null, overlay = false }) => {
    return (
        <LoadingContainer
            containerHeight={containerHeight}
            containerWidth={containerWidth}
            imgHeight={imgHeight}
            imgWidth={imgWidth}
            imgMarginTop={imgMarginTop}
            overlay={overlay}
        >
            <img src={LoadingAnimation} alt='loading' />
        </LoadingContainer>
    );
};

export { useLoading, LoadingView, LoadingWrapper };
export default Loading;
